<template>
    <section class="partenaires-section">
        <div class="row titre-partenaires-home">
            <div class="col-12 titre-partenaires-home-text">
                Nos Partenaires
            </div>
        </div>
        <div v-if="!is_loading">
            <CarousselPartenaire :partenaires="this.partenaires" />
        </div>
        <div v-if="is_loading" class="row">
            <LoaderSpinner id="loader-spinner" />
        </div>
    </section>
</template>

<script>
    import LoaderSpinner from './utils/Loader.vue'
    import CarousselPartenaire from './CarousselPartenaire.vue'
    import axios from 'axios'

    export default {
        name: "PartenairesHome",
        components: {
            LoaderSpinner,
            CarousselPartenaire
        },
        data() {
            var is_loading = true;

            return {
                partenaires: this.getPartenaires(),
                is_loading
            }
        },
        methods: {
            async getPartenaires() {
                let config = {
                    method: 'get',
                    url: '/api/partenaires/all',
                    headers: {
                        "Content-Type": "application/json"
                    }
                }

                await axios(config)
                    .then((response) => {
                        switch(response.status) {
                            case 200:
                                this.partenaires = response.data;
                                this.partenaires.forEach(p => {
                                    p.sourceLogo = require(`../assets/partenaires/logos/${p.logo}`);
                                });
                                break;
                            case 204:
                            default:
                                this.partenaires = [];
                        }

                        this.is_loading = false;
                    })
                    .catch((error) => {
                        console.log(error);
                        this.partenaires = [];

                    });
            }
        }
    }
</script>

<style lang="scss">
    .partenaires-section {
        min-height: 90vh;
        margin-top: 2em;
    }

    .titre-partenaires-home {
        min-height: 25vh;
        align-items: center;
    }

    .titre-partenaires-home-text {
        font-size: 3.5em;
    }

    #loader-spinner {
        margin-bottom: 3em;
        margin-top: 2em;
        height: 3em;
    }

    @media (max-width: 576px) {
        .partenaires-section {
            min-height: 75vh;
        }

        .titre-partenaires-home {
            min-height: 0;
        }
    }
</style>